import constants from '../../constants'

export function getCgmTypeFromHostname(hostname) {
  const host = String(hostname ?? window.location.hostname).toLowerCase()
  if (host.includes('glucolive')) return constants.CGM_TYPE.GLUCOLIVE
  if (host.includes('diasens')) return constants.CGM_TYPE.DIASENS
  if (host.includes('goodflip')) return constants.CGM_TYPE.GOODFLIP
  return constants.CGM_TYPE.GOODFLIP
}
